<template>
  <div class="myApp">
    <div class="my-head">
      <div class="setting-img">
        <img src="../../assets/setting.png" alt="" style="opacity: 0" />
      </div>
      <div class="user-info-contain">
        <div
          :class="
            user ? 'user-info my-flex-between' : 'user-info1 my-flex-between'
          "
          @click="toLogin()"
        >
          <div :class="memberInfo.card_num ? 'user-logo1' : 'user-logo'">
            <img
              :src="
                user && user.avatar
                  ? user.avatar
                  : require('../../assets/defaultLogo.png')
              "
              alt=""
            />
          </div>
          <div class="user-info-middle">
            <div class="my-flex" style="margin-bottom: 0.12rem">
              <div
                class="user-phone"
                v-text="
                  user && user.mobile
                    ? memberInfo.name
                      ? memberInfo.name
                      : user.mobile
                    : '点击登录'
                "
              ></div>
              <div
                style="margin: 0"
                class="user-tip-item1"
                v-if="memberInfo.is_employee"
              >
                <div v-text="'工号：' + memberInfo.employee_id"></div>
              </div>
            </div>
            <div
              class="ykt"
              v-if="memberInfo.card_num && memberInfo.outsourcing_company_name"
            >
              <div>
                <font>一卡通</font><span v-text="memberInfo.card_num"></span>
              </div>
              <div
                class="ykt_cmp"
                v-text="memberInfo.outsourcing_company_name"
              ></div>
            </div>
            <div class="ykt" v-else-if="memberInfo.card_num">
              <div>
                <font>一卡通</font><span v-text="memberInfo.card_num"></span>
              </div>
            </div>
            <div class="ykt1" v-else-if="memberInfo.outsourcing_company_name">
              <span v-text="memberInfo.outsourcing_company_name"></span>
            </div>
            <div v-if="user">
              <div
                class="user-tip my-flex"
                v-if="memberInfo.employee_status == 1"
              >
                <div class="user-tip-item">在职</div>
                <div
                  class="user-tip-item"
                  v-text="memberInfo.company_name"
                  v-if="memberInfo.company_name"
                ></div>
                <div
                  class="user-tip-item"
                  v-text="memberInfo.entry_job_name"
                  v-if="memberInfo.entry_job_name"
                ></div>
              </div>
              <div class="user-tip my-flex" v-else>
                <div class="user-tip-item">未入职</div>
              </div>
            </div>
            <div class="user-tip-login" v-else>立即登录，体验更多功能</div>
          </div>
          <img class="img-more" src="../../assets/moreLight.png" alt="more" />
        </div>
      </div>
    </div>
    <div class="level my-flex" v-if="user">
      <div class="level-item border-right">
        <div class="level-item-star level-item-top">
          <img
            :src="
              require(Number(memberInfo.star) >= 1
                ? '../../assets/starLight.png'
                : '../../assets/starDark.png')
            "
            alt="star"
          />
          <img
            :src="
              require(Number(memberInfo.star) >= 2
                ? '../../assets/starLight.png'
                : '../../assets/starDark.png')
            "
            alt="star"
          />
          <img
            :src="
              require(Number(memberInfo.star) >= 3
                ? '../../assets/starLight.png'
                : '../../assets/starDark.png')
            "
            alt="star"
          />
          <img
            :src="
              require(Number(memberInfo.star) >= 4
                ? '../../assets/starLight.png'
                : '../../assets/starDark.png')
            "
            alt="star"
          />
          <img
            :src="
              require(Number(memberInfo.star) >= 5
                ? '../../assets/starLight.png'
                : '../../assets/starDark.png')
            "
            alt="star"
          />
        </div>
        <div class="">星级</div>
      </div>
      <div class="level-item border-right">
        <div class="level-item-top">
          <img
            class="level-item-level-img"
            src="../../assets/level.png"
            alt="level"
          />
        </div>
        <div class="">等级</div>
      </div>
      <div class="level-item">
        <div
          class="level-item-hours level-item-top"
          v-text="memberInfo.work_hours ? memberInfo.work_hours : 0"
        ></div>
        <div class="">时长(时)</div>
      </div>
    </div>
    <div
      :class="
        user ? 'resume1 my-flex-between' : 'resume1 my-flex-between to-up'
      "
      v-if="true"
    >
      <div class="resume-left">
        <div class="resume-left-1">我的简历</div>
        <div class="resume-left-2">完善简历提高您的录取率</div>
        <div
          :class="systemType == 'android' ? 'resume-left-3' : 'resume-left-33'"
          @click="topeopleinfo()"
        >
          去完善
        </div>
      </div>
      <!-- <div class="resume-right" v-if="user">
        <img :src="proImg" alt="" />
        <div
          :class="systemType == 'ios' ? 'progressNum' : 'progressNum1'"
          v-text="proNum + '%'"
        ></div>
      </div> -->
    </div>
    <div class="my-request">
      <div class="my-flex-between my-request-top">
        <div class="my-request-title">我的申请</div>
        <div class="my-flex my-request-more" @click="toMyApply(0)">
          <span>查看全部</span> <img src="../../assets/moreDark.png" alt="" />
        </div>
      </div>
      <div class="my-request-bottom my-flex-around">
        <div class="" @click="toMyApply(1)">
          <img src="../../assets/ybm.png" alt="" />
          <div>已报名</div>
        </div>
        <div class="" @click="toMyApply(2)">
          <img src="../../assets/dms.png" alt="" />
          <div>待面试</div>
        </div>
        <div class="" @click="toMyApply(3)">
          <img src="../../assets/drz.png" alt="" />
          <div>待入职</div>
        </div>
      </div>
    </div>
    <div class="more-server" style="display: none">
      <div class="server-title">更多服务</div>
      <div class="server-list my-flex-around">
        <div @click="toMyCollect()">
          <img src="../../assets/myCollect.png" alt="" />
          <div>我的收藏</div>
        </div>
        <div @click="toMyHistoryJob()">
          <img src="../../assets/historyJob.png" alt="" />
          <div>历史职位</div>
        </div>
        <div @click="toBack()">
          <img src="../../assets/getReturn.png" alt="" />
          <div>我要反馈</div>
        </div>
        <div @click="toAboutUs()">
          <img src="../../assets/aboutUs.png" alt="" />
          <div>关于我们</div>
        </div>
      </div>
    </div>
    <eject
      :kzType="kzType"
      :showstate="kzShow"
      :msg="kzMsg"
      @toCancel="cancelFall"
      @took="okFall"
    ></eject>
  </div>
</template>
<style scoped>
@import "./my.css";
</style>
<script>
import eject from "../../components/eject.vue";
export default {
  name: "My",
  components: {
    eject, //弹框插件
  },
  data() {
    return {
      //弹框相关参数
      kzType: 0,
      kzMsg: "",
      kzShow: false,

      user: "",
      memberInfo: "",
      systemType: "android",
      proImg: "../../assets/progress/0.png",
      proNum: 0,
      showLoading: 0,
    };
  },
  mounted() {
    this.setUser();
  },
  methods: {
    toMyApply(type) {
      //我的申请
      if (!this.user) {
        this.$parent.loginShow = true;
      } else {
        this.$parent.childPageName = "MyApply";
        this.$parent.childPageData = { tid: type };
        this.$parent.toPage();
      }
    },
    setUser() {
      if (this.$user) {
        // console.log(this.$user);
        this.user = this.$user;
        this.getMemberInfo();
      }
    },
    getMemberInfo() {
      let that=this;
      let config = {
        headers: {
          token: this.user.token,
        },
      };
      //获取用户信息
      this.$http
        .post("/api/v1/user/my", {}, config)
        .then((res) => {
          console.log(res);
          that.memberInfo=res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    topeopleinfo() {
      //完善简历
      if (!this.user) {
        this.$parent.loginShow = true;
      } else {
        this.$parent.childPageName = "UserInfo";
        this.$parent.toPage();
      }
    },
    toLogin() {
      //登录
      if (!this.user) {
        this.$parent.loginShow = true;
      } else {
        this.$parent.childPageName = "UserInfo";
        this.$parent.toPage();
      }
    },
    cancelFall() {
      this.kzShow = false;
    },
    okFall() {
      this.kzShow = false;
    },
  },
};
</script>